import React from 'react'
import { useSelector } from 'react-redux'
import { groupBy, sortBy, isUndefined, isEmpty } from 'lodash'
import RootState from '../../../interfaces/RootState'

const LimitingFactorsComponent: React.ElementType = () => {
  const limitingFactorsResponse = (state: RootState) => state.limitingFactors.create.responseAttributes
  const limitingFactors = useSelector(limitingFactorsResponse)

  const planSearch = (state: RootState) => state.carrierVerification.plans.plans
  const plans = useSelector(planSearch)

  const planName = (planId: string) => {
    const matchedPlan = plans.find((plan: { id: string }) => plan.id === planId)
    return isUndefined(matchedPlan) ? 'n/a' : matchedPlan.name
  }

  const buildRows = () => {
    const codes = groupBy(limitingFactors, 'code')
    const rows = Object.keys(codes).map((code) => (
      codes[code][0].plan_ids.map((id) => ({ code, id, ...{ name: planName(id) } }))))

    return sortBy(rows.flat(), ['name'], ['asc']).map((plan) => (
      <div className="box box--table box--hover flex-box" key={`plan_${plan.id}`}>
        <div className="flex-box__item flex-box__item--grow" key={`name_${plan.id}`}>{plan.name}</div>
        <div className="flex-box__item" key={`id_${plan.id}`}>{plan.id}</div>
        <div className="flex-box__item" key={`code_${plan.id}`}>{plan.code}</div>

      </div>
    ))
  }

  if (isEmpty(limitingFactors)) {
    return (
      <div className="box box--table flex-box buffer-top--sm buffer-bottom--sm">
        <div className="flex-box__item name"><strong>No limiting factors found</strong></div>
      </div>
    )
  }

  return (
    <>
      <div className="box box--table flex-box">
        <div className="flex-box__item flex-box__item--grow"><strong>Name</strong></div>
        <div className="flex-box__item"><strong>ID</strong></div>
        <div className="flex-box__item"><strong>Limiting Factor</strong></div>
      </div>
      {buildRows()}
    </>
  )
}

export default LimitingFactorsComponent
